export default __webpack_public_path__ + "static/media/prize.min.4e70a785.png";